import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const LabelStyles = ({ theme, height, labelType }) => {
  const PackageCard = theme?.components?.PackageCard
  const labelInside =
    labelType === 'contentfulLabel' && PackageCard?.label?.inside

  const labelOffset = `-${
    height +
    parseInt(
      labelInside ? 0 : PackageCard?.stroke?.width?.replace('px', '') || 8,
      10
    )
  }px`

  return css`
    left: 0;
    right: 0;
    z-index: 2;
    font-size: 12px;
    padding: 4px 24px;
    font-weight: bold;
    line-height: 18px;
    width: fit-content;
    max-width: calc(100% - 4px);
    // the 4px accounts for the border radius. Reading from the theme -> packageCard.radius isn't working inside the calc function
    letter-spacing: 1px;
    text-transform: capitalize;
    text-align: ${PackageCard?.alignment};

    // THEME LEVEL STYLES
    position: ${labelInside ? 'unset' : 'absolute'};
    z-index: ${labelInside ? '1' : '-1'};
    top: ${labelInside ? '0' : labelOffset};
    margin: ${labelInside ? '0' : '0 auto'};
    background-color: ${PackageCard?.label?.backgroundColor ||
    theme.colors.primary.dark.hex};
    color: ${PackageCard?.label?.color || theme.colors.primary.dark.readable};
    border-radius: ${PackageCard?.label?.inside &&
    labelType === 'contentfulLabel'
      ? PackageCard?.label?.radius || PackageCard?.radius
      : '0px'};
    // If the label is inside the card, use the radius from the card
    // If on the outside, use the PackageCard radius || 4px
    border-top-left-radius: ${PackageCard?.label?.inside &&
    labelType === 'contentfulLabel'
      ? PackageCard?.label?.radius
      : PackageCard?.radius || '6px'};

    border-top-right-radius: ${PackageCard?.label?.inside &&
    labelType === 'contentfulLabel'
      ? PackageCard?.label?.radius
      : PackageCard?.radius || '6px'};

    ${labelType === 'brandyLabel' &&
    `
      font-size: ${
        PackageCard?.labelOffer?.size ||
        `${theme?.fonts?.body?.md?.size}px` ||
        '16px'
      };

      line-height: ${
        PackageCard?.labelOffer?.lineHeight ||
        `${theme?.fonts?.body?.md?.lineHeight}px` ||
        '16px'
      };

      span {
        display: block;
        opacity: ${PackageCard?.labelOffer?.legal?.opacity || '0.8'};

        font-size: ${
          theme?.body?.legal?.size
            ? theme?.body?.legal?.size
            : theme?.body?.xs?.size || '10px'
        };

        line-height: ${
          theme?.body?.legal?.lineHeight
            ? theme?.body?.legal?.lineHeight
            : theme?.body?.xs?.lineHeight || '12px'
        };
      }
    `};
  `
}

export const Label = styled.div(LabelStyles)
